import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";

function highlight(text = "", highlight = "") {
    try {
        if (!text || !highlight) {
            return [{ text: text || "", highlight: false }];
        }

        const matches = match(text, highlight, { insideWords: true });
        const parts = parse(text, matches);
        return parts || [{ text, highlight: false }];
    } catch {
        return [{ text: text || "", highlight: false }];
    }
}

export default highlight;
